<template>
  <v-layout column wrap fill-height class="toolbox-window grey">
    <v-toolbar dense dark color="grey darken-3" class="toolbox-window__toolbar">
      <v-avatar color="primary" size="30">
        <v-icon small dark>{{ icon }}</v-icon>
      </v-avatar>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <slot name="toolbar"></slot>
    </v-toolbar>

    <div class="toolbox-window__content">
      <v-layout row wrap class="toolbox-window__content-layout">
        <slot></slot>
      </v-layout>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'ToolboxWindow',
  props: {
    title: {
      required: true,
      type: String
    },
    icon: {
      required: true,
      type: String
    }
  }
}
</script>

<style scoped lang="scss">
.display-flex {
  display: flex;
}

.toolbox-window__toolbar {
  flex: 0 1 auto;
  width: 100%;
}

.toolbox-window__content {
  position: relative;
  flex: 1 1 auto;
  overflow: scroll;

  .toolbox-window__content-layout {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
}
</style>
